export default __webpack_public_path__ + "static/media/glisten-logo.7694b9c1.svg";